export default "__VITE_ASSET__Bdvfmmlm__"